import { render, staticRenderFns } from "./deanInputSelect.vue?vue&type=template&id=1c8eb756&scoped=true"
import script from "./deanInputSelect.vue?vue&type=script&lang=ts"
export * from "./deanInputSelect.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelect.vue?vue&type=style&index=0&id=1c8eb756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8eb756",
  null
  
)

export default component.exports